export default __webpack_public_path__ + "static/media/HarmonyOneWallet.de6b3b08.png";